const SelectConverterType = ({ ConverterTypes, selectedConverterType, setSelectedConverterType }) => {
    return (
        <select
        id='converter-type-select'
        className='type-select-style'
        value={selectedConverterType}
        onChange={(e) => setSelectedConverterType(e.target.value)}
        >
            {selectedConverterType === '' ? <option value="">
                ------
            </option> : null}
            {ConverterTypes.map((converterType) => (
                <option
                    key={converterType[1]}
                    value={converterType[0]}
                >
                    {converterType[1]}
                </option>
            ))}
        </select>
    );
};

export default SelectConverterType;